import { useTranslation } from 'react-i18next'

import { AvatarWithStatus } from '../../../../../Avatar'
import { EntityProfileHeaderInfoItemBase } from '../../../../../Entity'
import Text from '../../../../../Text'
import { ProfileUserInfoItem } from '../../../../../Widget'
import { toListingProfileUserValue } from '../../RentalPortalListingProfile.utils'
import {
  LISTING_PROFILE_INFO_ITEM_TITLE_KEY,
  QA_NAME_LISTING_PROFILE_INFO_RESPONSIBLE_MANAGER,
} from '../RentalPortalListingProfileHeaderInfoItems.constants'
import {
  getListingProfileHeaderInfoItemActions,
  getListingProfileManagerItemProps,
} from '../RentalPortalListingProfileHeaderInfoItems.utils'

function ListingProfileResponsibleManagerItem({
  actionButtonClassName,
  actionsWrapperClassName,
  canEdit,
  className,
  contentWrapperClassName,
  managerClassName,
  titleClassName,
  value,
  onOpenModal,
}) {
  const { t } = useTranslation()

  return (
    <EntityProfileHeaderInfoItemBase
      {...getListingProfileManagerItemProps({
        actionButtonClassName,
        actionsWrapperClassName,
        canEdit,
      })}
      className={className}
      contentExist={Boolean(value)}
      contentWrapperClassName={contentWrapperClassName}
      handlers={getListingProfileHeaderInfoItemActions(onOpenModal)}
      title={LISTING_PROFILE_INFO_ITEM_TITLE_KEY.responsibleManager}
      titleClassName={titleClassName}
      value={value?.id}
    >
      {value ? (
        <ProfileUserInfoItem
          AdditionalInfo={null}
          ContentAvatar={AvatarWithStatus}
          className={managerClassName}
          hoverClassName={null}
          isArchived={Boolean(value.is_archived)}
          textQaName={QA_NAME_LISTING_PROFILE_INFO_RESPONSIBLE_MANAGER}
          value={toListingProfileUserValue(value)}
        />
      ) : (
        <Text
          disabled
          isSecondary
          qaName={QA_NAME_LISTING_PROFILE_INFO_RESPONSIBLE_MANAGER}
        >
          {t('Select.NoDataKey')}
        </Text>
      )}
    </EntityProfileHeaderInfoItemBase>
  )
}

export default ListingProfileResponsibleManagerItem
